module.exports = __webpack_public_path__ + "media/images/sponsor/young-pin-design-award@2x-02e2af7508e9142d2e86051c7cbed1e6.png";